import Vue from 'vue'
import axios from 'axios'

const defaultConfig = {
  baseUrl: '/',
  id: '_id',
  defaults: {}
}

const getUrl = (baseUrl, id) => {
  return `${baseUrl}${id != null && id !== false ? '/' + id : ''}`
}

export default (config = {}) => {
  config = { ...defaultConfig, ...config }
  return {
    namespaced: true,
    state: {
      config,
      attributes: {},
      isNew: true,
      active: false,
      loading: false
    },
    actions: {
      async configure ({state, commit}, configData = {}) {
        commit('UPDATE_CONFIG', configData)
      },
      async fetch ({commit, state, dispatch}, id) {
        try {
          commit('LOADING', true)
          dispatch('activate')
          if (state.isNew) commit('CHANGE_NEW', false)
          const url = getUrl(state.config.baseUrl, id)
          const result = await axios.get(url)
          commit('FETCH_SUCCESS', result)
        } catch (err) {
          console.error('[model error]', err)
          commit('ERROR', err)
        } finally {
          commit('LOADING', false)
        }
      },
      new ({ state, commit, dispatch }, data) {
        if (!state.isNew) commit('CHANGE_NEW', true)
        commit('FETCH_SUCCESS', {data: data || state.config.defaults || {}})
        dispatch('activate')
      },
      async activate ({state, commit}, value) {
        if (!state.active) commit('CHANGE_ACTIVE', true)
      },
      async deactivate ({state, commit}, value) {
        if (state.active) commit('CHANGE_ACTIVE', false)
      },
      async saveUrl ({ commit, dispatch, state }, data) {
        try {
          commit('LOADING', true)
          const result = await axios.put(state.config.baseUrl, data)
          commit('SAVE_SUCCESS', result)
          if (state.isNew) {
            commit('CHANGE_NEW', false)
          }
          return result
        } catch (err) {
          console.error('[model error]', err)
          commit('ERROR', err)
        } finally {
          commit('LOADING', false)
        }
      },
      async save ({ commit, dispatch, state }, data) {
        try {
          commit('LOADING', true)
          let result
          if (state.isNew) {
            result = await axios.post(state.config.baseUrl, data || state.attributes)
          } else {
            const updateUrl = getUrl(state.config.baseUrl, state.attributes[state.config.id])
            result = await axios.put(updateUrl, data || state.attributes)
          }
          commit('SAVE_SUCCESS', result)
          if (state.isNew) {
            commit('CHANGE_NEW', false)
          }
          return result
        } catch (err) {
          console.error('[model error]', err)
          commit('ERROR', err)
        } finally {
          commit('LOADING', false)
        }
      },
      reset ({ commit }) {
        commit('RESET')
      },
      async destroy ({ state, commit, dispatch }, id) {
        try {
          commit('LOADING', true)
          const anyId = id || state.attributes[state.config.id]
          if (!anyId) throw new Error('No id found')
          const result = await axios.delete(getUrl(state.config.baseUrl, anyId))
          dispatch('deactivate')
          commit('FETCH_SUCCESS', result)
          return result
        } catch (err) {
          console.error('[model error]', err)
          commit('ERROR', err)
        } finally {
          commit('LOADING', false)
        }
      },
      updateAttributes ({ commit, state }, data = {}) {
        commit('UPDATE_ATTRIBUTES', data)
        commit('CHANGE_NEW', data[state.config.id] == null)
      }
    },
    mutations: {
      UPDATE_CONFIG (state, config) {
        Vue.set(state, 'config', { ...state.config, ...config })
      },
      UPDATE_ATTRIBUTES (state, dataObj) {
        Object.keys(dataObj).forEach((key) => {
          Vue.set(state.attributes, key, dataObj[key])
        })
      },
      CHANGE_NEW (state, value) {
        state.isNew = value
      },
      CHANGE_ACTIVE (state, active) {
        state.active = active
      },
      LOADING (state, value) {
        state.loading = value
      },
      FETCH_SUCCESS (state, axiosResult) {
        Vue.set(state, 'attributes', axiosResult.data)
      },
      SAVE_SUCCESS (state, axiosResult) {
        Vue.set(state, 'attributes', axiosResult.data)
      },
      DESTROY_SUCCESS (state, axiosResult) {
        Vue.set(state, 'attributes', axiosResult.data)
      },
      ERROR (state, err = '') {
        Vue.set(state, 'error', err.message || err.toString())
      },
      RESET (state) {
        Vue.set(state, 'config', config)
        Vue.set(state, 'attributes', {})
        Vue.set(state, 'isNew', true)
        Vue.set(state, 'active', false)
        Vue.set(state, 'loading', false)
      }
    },
    getters: {}
  }
}



// WEBPACK FOOTER //
// ./src/plugin/model.js